import R from 'ramda'
import {createSelector} from 'reselect'

import currentSortColumn from './currentSortColumn'
import currentSortOptions from './currentSortOptions'

export default createSelector(
  [
    currentSortColumn,
    currentSortOptions,
  ], 
  (sortColumn, sortOptions) => R.find(R.propEq('name', sortColumn), sortOptions)
) 



/** WEBPACK FOOTER **
 ** ./app/selectors/currentSortOption.js
 **/